import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.825 18.52a2.42 2.42 0 0 1-1.76-.741L2.14 12.866l.48-.468q.228-.207.515-.268.286-.06.582.012l2.784.687v-8.31q0-.212.144-.356a.49.49 0 0 1 .357-.144q.213 0 .356.144a.49.49 0 0 1 .143.356v9.652l-3.636-.982 3.915 3.896a1.5 1.5 0 0 0 1.046.434H12.5q1.056 0 1.778-.722T15 15.02v-4q0-.212.144-.356a.49.49 0 0 1 .357-.144q.212 0 .356.144a.49.49 0 0 1 .143.356v4q0 1.458-1.021 2.479-1.02 1.02-2.475 1.021zm.502-6.5v-4q0-.215.144-.357a.49.49 0 0 1 .357-.144q.212 0 .356.144a.49.49 0 0 1 .143.356v4zm2.846 0v-3q0-.215.144-.357a.49.49 0 0 1 .357-.144q.213 0 .356.144a.49.49 0 0 1 .143.356v3zM18 4.903h-4.384v-.885H16.9a16 16 0 0 0-3.704-2.263Q11.2.886 9 .885q-2.2 0-4.196.87A16 16 0 0 0 1.1 4.02h3.285v.885H0V.519h.885v2.506A16.6 16.6 0 0 1 4.715.833 11.3 11.3 0 0 1 9 0q2.235 0 4.284.833a16.6 16.6 0 0 1 3.832 2.192V.519H18z"
    }, null, -1)
  ]))]))
}
export default { render: render }